/*
	global track
*/
import Vue from 'vue';
import App from './App.vue';
import router from './router.js';

import android from '@flyme/jr/js/android.js';
/**
 *
 * @author: Lumend
 * @date:  2017-11-28 11:47
 * @contact: yinminzhi@meizu.com
 * @description: #埋点
 */
window.track = function(name, params) {
	var data = {
		eventName: name,
		pageName: 'ecash'
	};

	var channelId = getPar('channel_id') || localStorage.getItem('channel_id');
	data.property = {
		channel_id: channelId || 0
	};
	if (params !== undefined) {
		for( var i in params){
			data.property[i] = params[i];
		}
	}
	console.log('trach', data, name);

	android('onEventWithProperty', data);
};

window.Finish = function(pageName, ext) {
	var data = {
		pages: pageName
	};
	if (ext) {
		for (var i in ext) {
			data[i] = ext[i];
		}
	}
	android('finishModule', {
		result: true,
		data: data
	});
};

Number.prototype.Format = String.prototype.Format = function() {
	var num = this.toString().replace(/\$|,/g, '');
	if (isNaN(num))
		num = "0";
	var sign = (num == (num = Math.abs(num)));
	num = Math.floor(num * 100 + 0.50000000001);
	var cents = num % 100;
	num = Math.floor(num / 100).toString();
	if (cents < 10)
		cents = "0" + cents;
	for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
		num = num.substring(0, num.length - (4 * i + 3)) + ',' +
		num.substring(num.length - (4 * i + 3));
	return (((sign) ? '' : '-') + num + '.' + cents);
};

Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
};

function getPar(name) {
	var arry = location.hash.substr(location.hash.search(/\?/)).substr(1).split('&');
	var res = '';
	arry.forEach(function(v) {
		var a = v.split('=');
		if (a[0] === name) {
			res = a[1];
			return false;
		}
	});
	return (res === undefined ? undefined : decodeURIComponent(res));
}


router.beforeEach((to, from, next) => {
	var path = to.path;
	var p = (path === '/') ? '_home' : path.replace(/\//g, '_');

	if (path === '/') {
		var source = getPar('channel_id');
		if (source) {
			localStorage.setItem('channel_id', source);
		} else {
			localStorage.removeItem('channel_id');
		}
	}

	track('page_ecash' + p);

	next();
});

function getToken(cb) {
	android('getToken', {
		isForceUpdate: false
	}, (token) => {
		window.token = token;
		// window.token = 'eyJ2IjozLCJnIjpmYWxzZSwidSI6IjExMzU0Mjg1MCIsInQiOjE1MjgxMDI1MDgzODcsInMiOiJucyIsImMiOiIxIiwiciI6InJRZ0ltT0dYS1llNUhZbUJYUzVOIiwiYSI6IjQwN0FDRTk4NzMwMUI2NjczNTdGMTkyQjc4NzAzOEUwIiwibCI6IjI5OTU4NjM5RTY2ODM5NjQ3Q0UxODUwQjIwOENCQzQzIn0';
		cb();
	});
}

function buildVue() {
	new Vue({
		router,
		render: h => h(App)
	}).$mount('#app');
}

getToken(buildVue);


// WEBPACK FOOTER //
// ./src/main.js